//-----------------------------------------------------------------------------
// Michael B. Gale's Website
// Copyright (c) 2022 Michael B. Gale (github@michael-gale.co.uk)
//-----------------------------------------------------------------------------

import * as React from "react";

//-----------------------------------------------------------------------------

export interface LinkedProps {
    url?: string;
    me?: boolean;
}

export const Linked = (props: React.PropsWithChildren<LinkedProps>) => {
    const rels = [];

    if(props.me) {
        rels.push("me");
    }

    return props.url ? <a rel={rels.join(' ')} href={props.url}>{props.children}</a> : <>{props.children}</>;
}

export default Linked;

//-----------------------------------------------------------------------------
